import type { PropsWithChildren } from 'react';
import { Children, memo } from 'react';
import type { FlexProps } from '@chakra-ui/react';
import { Flex } from '@chakra-ui/react';

const variants = {
  primary: {
    backgroundColor: 'primary400',
    boxShadow: 'dotPrimary400',
  },
  secondary: {
    backgroundColor: 'secondary400',
    boxShadow: 'dotSecondary400',
  },
};

type Props = {
  variant?: 'primary' | 'secondary';
} & Omit<
  FlexProps,
  'justifyContent' | 'alignItems' | 'backgroundColor' | 'boxShadow' | 'borderRadius'
>;

export const Dot = memo(({ variant = 'primary', children, ...props }: PropsWithChildren<Props>) => {
  const childrenCount = Children.count(children);

  return (
    <Flex
      justifyContent='center'
      alignItems='center'
      borderRadius='full'
      px={1}
      py={childrenCount > 0 ? 0 : 1}
      {...variants[variant]}
      {...props}>
      {children}
    </Flex>
  );
});
